export class EntityNotFoundError extends Error {
    constructor(public readonly entityID: any) {
        super('An entity could not be found');

        Object.setPrototypeOf(this, EntityNotFoundError.prototype);
    }
}
